import { useEffect, useState } from "react";
import { brand, footerGroups, navLinks } from "@/mocks/baoliaoData";

export default function SiteFooter() {
  const [showTop, setShowTop] = useState(false);

  const groupHref: Record<string, string> = {
    内容栏目: "#hot",
    关于站点: "#about",
    热门话题: "#topics",
  };

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <footer className="bg-background-100 border-t border-background-200/80">
        <div className="max-w-[1240px] mx-auto px-4 md:px-6 py-10 md:py-14">
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
            {/* brand */}
            <div className="col-span-2">
              <a href="#headline" className="flex items-center gap-2">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-flashlight-fill text-lg"></i>
                </span>
                <span className="font-heading font-extrabold text-xl text-foreground-950">
                  {brand}
                  <span className="text-primary-500">.</span>
                </span>
              </a>
              <p className="mt-4 text-[13px] leading-relaxed text-foreground-600 max-w-xs">
                以实时爆料的快节奏为底色，用热点追踪的进度化梳理补齐来龙去脉。今日热点、全网热瓜，一屏读懂。
              </p>
              <div className="flex items-center gap-2 mt-5">
                {["weibo", "wechat", "qq"].map((ic) => (
                  <a
                    key={ic}
                    href="#headline"
                    aria-label={`关注我们 ${ic}`}
                    className="w-9 h-9 flex items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-600 hover:text-primary-600 hover:border-primary-300 transition-colors"
                  >
                    <i className={`ri-${ic}-line`}></i>
                  </a>
                ))}
              </div>
            </div>

            {footerGroups.map((g) => (
              <div key={g.title}>
                <h4 className="font-heading font-bold text-sm text-foreground-950 mb-4">{g.title}</h4>
                <ul className="flex flex-col gap-2.5">
                  {g.links.map((l) => (
                    <li key={l}>
                      <a
                        href={groupHref[g.title] || "#headline"}
                        className="text-[13px] text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                      >
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* disclaimer */}
          <div className="mt-10 pt-6 border-t border-background-200/80">
            <p className="text-xs leading-relaxed text-foreground-500">
              声明：{brand} 内容基于公开可见信息与多方信源整理，均属资讯转载性质，不代表本站立场。处于核实状态的信息会明确标注，并对涉及当事人的表述保持审慎。若相关内容涉及您的合法权益，欢迎通过邮件联系我们处理。
            </p>
          </div>
        </div>

        <div className="border-t border-background-200/80 bg-background-200/50">
          <div className="max-w-[1240px] mx-auto px-4 md:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
            <p className="text-xs text-foreground-600">
              © {new Date().getFullYear()} {brand} · 实时爆料 · 全网热瓜 · 热点追踪
            </p>
            <nav className="flex items-center gap-4">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {l.label}
                </a>
              ))}
            </nav>
          </div>
        </div>
      </footer>

      {/* back to top */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-400 transition-all duration-300 ${
          showTop ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </button>
    </>
  );
}